(function(){
    document.addEventListener('DOMContentLoaded', function() {
        const hstrActive =  document.querySelector('main[data-hstr]');
        const maxItems = 12;
        const keyStorage = 'hstr';
        if(hstrActive) {
            const data = JSON.parse(hstrActive.getAttribute('data-hstr'));
            if (typeof(Storage) !== "undefined") {
                const hstr = JSON.parse(localStorage.getItem(keyStorage)) || [];
                const index = hstr.findIndex(h => h.id === data.id);
                if(index !== -1) {
                    hstr.splice(index, 1);
                }
                hstr.unshift(data);
                if(hstr.length > maxItems) {
                    hstr.pop();
                }
                localStorage.setItem(keyStorage, JSON.stringify(hstr));
            }
        }
    });
})()
